<template>
    <Layout is-crm :content-class="'content--narrow'">
        <Spinner v-if="loading" />
        <h1>employee {{ $route.params.id }}</h1>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';

export default {
    name: 'EmployeeDetailsPage',
    components: {
        Layout,
        Spinner,
    },
    data() {
        return {
            loading: false,
        };
    },
};
</script>

<style lang="scss" src="./EmployeeDetailsPage.scss"></style>
